import store from "~/store"

/**
 * @description: 树形字典通过code获取label
 * @param {*}
 * @return {*}
 * @author: syx
 */
import {GetTreeItemByCode} from "~/functions/list-tree"

export const GetTreeLabelByCode = (
  val,
  type,
  options
) => { 
  const defaultOptions = {
    defaultVal: "",
    formatFun: (arr, treeSetting) => {
      return arr.map((item) => {
        return item[treeSetting.labelField]
      }).join(",")
    },
    treeSetting: {}
  }
  Object.assign(defaultOptions, options)
  return new Promise((resolve, reject) => {
    const {treeSetting} = store.state.dictConfig
    const resultSetting = Object.assign(treeSetting, defaultOptions.treeSetting)
    const dictList = store.state.dictCodes
     
    let list = []
    //如果没找到此类型的数据
    if (!dictList || !dictList[type]) {
      if (store.state.isGettingDictTypes.includes(type) || store.state.isGettingAllDictTypes) { //如果有别的地方在请求这个字典类型数据  轮询查看是否请求结束
        const timer = setInterval(() => {
          if (!(store.state.isGettingDictTypes.includes(type) || store.state.isGettingAllDictTypes)) {
            clearInterval(timer)
            list = store.state.dictCodes[type]
            if (!list) {
              reject(`不存在类型为：${type} 的字典字段，请确认后再填写`)
              return
            }
            const targetItem = list.find(item => { return item[resultSetting.idField] === val })
            resolve(targetItem ? defaultOptions.formatFun(GetTreeItemByCode(targetItem[resultSetting.idField], list, resultSetting), resultSetting) : defaultOptions.defaultVal) 
          }
        }, 1000)
      } else {
        store.actions.getDictDataObj(type).then((data) => {
          list = data[type]
          if (!list) {
            reject(`不存在类型为：${type} 的字典字段，请确认后再填写`)
            return
          }
          const targetItem = list.find((item) => { return item[resultSetting.idField] === val })
          resolve(targetItem ? defaultOptions.formatFun(GetTreeItemByCode(targetItem[resultSetting.idField], list, resultSetting), resultSetting) : defaultOptions.defaultVal) 
        })
      }
    } else {
      list = dictList[type]
      const targetItem = list.find(item => { return item[resultSetting.idField] === val })
      resolve(targetItem ? defaultOptions.formatFun(GetTreeItemByCode(targetItem[resultSetting.idField], list, resultSetting), resultSetting) : defaultOptions.defaultVal)
    }
  })
}
 
/**
  * @description: 树形数据通过codes 获取labels
  * @param {*}
  * @return {*}
  * @author: syx
  */
export function GetTreeLabelByCodesDothings(values, list, defaultVal, formatFunIn, resultSetting) {
  const targetArr = []
  for (let i = 0; i < values.length; i++) {
    const findItem = list.find(item => { return item[resultSetting.idField] === values[i] })
    if (findItem) {
      targetArr.push(formatFunIn(GetTreeItemByCode(findItem[resultSetting.idField], list, resultSetting), resultSetting))
    } else {
      targetArr.push(defaultVal)
    }
  }
  return targetArr
}

export const GetTreeLabelByCodes = (
  vals,
  type,
  options
) => {
  const defaultOptions = {
    defaultVal: "",
    formatFunIn: (arr, treeSetting) => {
      return arr.map((item) => {
        return item[treeSetting.labelField]
      }).join("/")
    },
    treeSetting: {},
    formatFunOut: (arr) => {
      return arr.join(",")
    },
    spacer: ","
  }
  Object.assign(defaultOptions, options)
  return new Promise((resolve, reject) => {
    let values = []
    if (Array.isArray(vals)) {
      values = vals
    } else if (typeof vals === "string") {
      values = vals.split(defaultOptions.spacer)
    }
 
    const {treeSetting} = store.state.dictConfig
    const resultSetting = Object.assign(treeSetting, defaultOptions.treeSetting)
    const dictList = store.state.dictCodes
     
    let list = []
    //如果没找到此类型的数据
    if (!dictList || !dictList[type]) {
      if (store.state.isGettingDictTypes.includes(type) || store.state.isGettingAllDictTypes) { //如果有别的地方在请求这个字典类型数据  轮询查看是否请求结束
        const timer = setInterval(() => {
          if (!(store.state.isGettingDictTypes.includes(type) || store.state.isGettingAllDictTypes)) {
            clearInterval(timer)
            list = store.state.dictCodes[type]
            if (!list) {
              reject(`不存在类型为：${type} 的字典字段，请确认后再填写`)
              return
            }
            const targetArr = GetTreeLabelByCodesDothings(values, list, defaultOptions.defaultVal, defaultOptions.formatFunIn, resultSetting)
            resolve(targetArr&&targetArr.length > 0 ? defaultOptions.formatFunOut(targetArr) : defaultOptions.defaultVal)
          }
        }, 1000)
      } else {
        store.actions.getDictDataObj(type).then((data) => {
          list = data[type]
          if (!list) {
            reject(`不存在类型为：${type} 的字典字段，请确认后再填写`)
            return
          }
          const targetArr = GetTreeLabelByCodesDothings(values, list, defaultOptions.defaultVal, defaultOptions.formatFunIn, resultSetting)
          resolve(targetArr&&targetArr.length > 0 ? defaultOptions.formatFunOut(targetArr) : defaultOptions.defaultVal)
        })
      }
    } else {
      list = dictList[type]
      const targetArr = GetTreeLabelByCodesDothings(values, list, defaultOptions.defaultVal, defaultOptions.formatFunIn, resultSetting)
      resolve(targetArr&&targetArr.length > 0 ? defaultOptions.formatFunOut(targetArr) : defaultOptions.defaultVal)
    }
  })
}
 
/**
  * @description: 树形数据通过label 获取code
  * @param {*}
  * @return {*}
  * @author: syx
  */
import {GetTreeItemByLabel} from "~/functions/list-tree"
//通过code获取label  树形数据使用
export const GetTreeCodeByLabel = (
  val,
  type,
  options
) => { 
  const defaultOptions = {
    defaultVal: "",
    formatFun: (arr, treeSetting) => {
      return arr.map((item) => {
        return item[treeSetting.idField]
      }).join(",")
    },
    treeSetting: {}
  }
  Object.assign(defaultOptions, options) 
  return new Promise((resolve, reject) => {
    const {treeSetting} = store.state.dictConfig
    const resultSetting = Object.assign(treeSetting, defaultOptions.treeSetting)
    const dictList = store.state.dictCodes
     
    let list = []
    //如果没找到此类型的数据
    if (!dictList || !dictList[type]) {
      if (store.state.isGettingDictTypes.includes(type) || store.state.isGettingAllDictTypes) { //如果有别的地方在请求这个字典类型数据  轮询查看是否请求结束
        const timer = setInterval(() => {
          if (!(store.state.isGettingDictTypes.includes(type) || store.state.isGettingAllDictTypes)) {
            clearInterval(timer)
            list = store.state.dictCodes[type]
            if (!list) {
              reject(`不存在类型为：${type} 的字典字段，请确认后再填写`)
              return
            }
            const targetItem = list.find(item => { return item[resultSetting.labelField] === val })
            resolve(targetItem ? defaultOptions.formatFun(GetTreeItemByLabel(targetItem[resultSetting.labelField], list, resultSetting), resultSetting) : defaultOptions.defaultVal) 
          }
        }, 1000)
      } else {
        store.actions.getDictDataObj(type).then((data) => {
          list = data[type]
          if (!list) {
            reject(`不存在类型为：${type} 的字典字段，请确认后再填写`)
            return
          }
          const targetItem = list.find((item) => { return item[resultSetting.labelField] === val })
          resolve(targetItem ? defaultOptions.formatFun(GetTreeItemByLabel(targetItem[resultSetting.labelField], list, resultSetting), resultSetting) : defaultOptions.defaultVal) 
        })
      }
    } else {
      list = dictList[type]
      const targetItem = list.find(item => { return item[resultSetting.labelField] === val })
      resolve(targetItem ? defaultOptions.formatFun(GetTreeItemByLabel(targetItem[resultSetting.labelField], list, resultSetting), resultSetting) : defaultOptions.defaultVal) 
    }
  })
}
 
/**
   * @description: 树形数据通过labels 获取codes
   * @param {*}
   * @return {*}
   * @author: syx
   */
export function GetTreeCodeByLabelsDothings(values, list, defaultVal, formatFunIn, resultSetting) {
  const targetArr = []
  for (let i = 0; i < values.length; i++) {
    const findItem = list.find((item) => { return item[resultSetting.labelField] === values[i] })
    if (findItem) {
      targetArr.push(formatFunIn(GetTreeItemByLabel(findItem[resultSetting.labelField], list, resultSetting), resultSetting))
    } else {
      targetArr.push(defaultVal)
    }
  }
  return targetArr
}

export const GetTreeCodeByLabels = (
  vals,
  type,
  options
) => {
  const defaultOptions = {
    defaultVal: "",
    formatFunIn: (arr, treeSetting) => {
      return arr.map((item) => {
        return item[treeSetting.idField]
      }).join("/")
    },
    treeSetting: {},
    formatFunOut: (arr) => {
      return arr.join(",")
    },
    spacer: ","
  }
  Object.assign(defaultOptions, options) 
  return new Promise((resolve, reject) => {
    let values = []
    if (Array.isArray(vals)) {
      values = vals
    } else if (typeof vals === "string") {
      values = vals.split(defaultOptions.spacer)
    }
  
    const {treeSetting} = store.state.dictConfig
    const resultSetting = Object.assign(treeSetting, defaultOptions.treeSetting)
    const dictList = store.state.dictCodes
      
    let list = []
    //如果没找到此类型的数据
    if (!dictList || !dictList[type]) {
      if (store.state.isGettingDictTypes.includes(type) || store.state.isGettingAllDictTypes) { //如果有别的地方在请求这个字典类型数据  轮询查看是否请求结束
        const timer = setInterval(() => {
          if (!(store.state.isGettingDictTypes.includes(type) || store.state.isGettingAllDictTypes)) {
            clearInterval(timer)
            list = store.state.dictCodes[type]
            if (!list) {
              reject(`不存在类型为：${type} 的字典字段，请确认后再填写`)
              return
            }
            const targetArr = GetTreeCodeByLabelsDothings(values, list, defaultOptions.defaultVal, defaultOptions.formatFunIn, resultSetting)
            resolve(targetArr&&targetArr.length > 0 ? defaultOptions.formatFunOut(targetArr) : defaultOptions.defaultVal)
          }
        }, 1000)
      } else {
        store.actions.getDictDataObj(type).then((data) => {
          list = data[type]
          if (!list) {
            reject(`不存在类型为：${type} 的字典字段，请确认后再填写`)
            return
          }
          const targetArr = GetTreeCodeByLabelsDothings(values, list, defaultOptions.defaultVal, defaultOptions.formatFunIn, resultSetting)
          resolve(targetArr&&targetArr.length > 0 ? defaultOptions.formatFunOut(targetArr) : defaultOptions.defaultVal)
        })
      }
    } else {
      list = dictList[type]
      const targetArr = GetTreeCodeByLabelsDothings(values, list, defaultOptions.defaultVal, defaultOptions.formatFunIn, resultSetting)
      resolve(targetArr&&targetArr.length > 0 ? defaultOptions.formatFunOut(targetArr) : defaultOptions.defaultVal)
    }
  })
}